import React from "react";
import { observer } from "mobx-react-lite";
import { ContainerSubTitleGrey } from "../../ContainerSubTitleGrey";
import { VirtualVersionList } from "./VirtualVersionList";
import { VERSION_REPORT_GRID_CLASS } from "./ItemVersionReport";
import Media from "../../../api/Media";

export const ListVersionReport = observer(
  ({ valueVersion, moveCompany, items, companys, searchQuery = "" }) => {
    if (items.length !== 0) {
      return (
        <div className="cc-v4-soft-list-root">
          <div className={`cc-v4-soft-header ${VERSION_REPORT_GRID_CLASS}`}>
            <span className="cc-v4-soft-th-static">
              <span className="cc-v4-soft-th-label">Компания</span>
            </span>
            <span className="cc-v4-soft-th-static">
              <span className="cc-v4-soft-th-label">ИНН</span>
            </span>
            <span className="cc-v4-soft-th-static">
              <span className="cc-v4-soft-th-label">Ответственный менеджер</span>
            </span>
            <span className="cc-v4-soft-th-static">
              <span className="cc-v4-soft-th-label">Менеджер сопровождения</span>
            </span>
            <span className="cc-v4-soft-th-static reports-th-numeric">
              <span className="cc-v4-soft-th-label">
                {Media.mobile ? "Шт" : "Кол-во"}
              </span>
            </span>
          </div>
          <div className="cc-v4-soft-body reports-version-virtual-body">
            <VirtualVersionList
              moveCompany={moveCompany}
              items={items}
              companys={companys}
            />
          </div>
        </div>
      );
    }
    const trimmedSearch = String(searchQuery ?? "").trim();
    const emptyText =
      trimmedSearch.length > 1
        ? `Ничего не найдено по запросу «${trimmedSearch}»`
        : `Не найдено программного обеспечения версии ${valueVersion} или ниже`;

    return <ContainerSubTitleGrey text={emptyText} />;
  },
);
